import {QuizConfig} from '@/global/types/quiz';

const profile: QuizConfig = {
    options: {
        page: {
            text: ['title', 'description', 'text', 'info', 'afterComponents']
        }
    },
    types: {
        dropdown: 'dropdown',
        collection: 'collection',
        textbox: 'textbox',
        textarea: 'textarea'
    },
    pages: [
        {
            id: 'workplace',
            allowedVersion: ['1.0', '1.1'],
            title: 'title',
            description: 'description',
            align: {
                title: 'center',
                description: 'center',
                text: 'center',
            },
            display: {
                country: ['USA', 'IND', 'CAN', 'BRA']
            },
            components: [{name: 'workplace'}]
        },
        {
            id: 'equipmentsurvey',
            allowedVersion: ['1.0'],
            title: 'title',
            description: 'description',
            info: 'info',
            align: {
                title: 'center',
                description: 'left',
                text: 'left',
                info: 'left'
            },
            display: {
                country: ['USA', 'IND', 'CAN', 'BRA']
            },
            components: []
        },
        {
            id: 'priority',
            allowedVersion: ['1.0'],
            title: 'title',
            description: 'description',
            align: {
                title: 'center',
                description: 'center',
                text: 'center'
            },
            display: {
                country: ['USA', 'IND', 'CAN', 'BRA']
            },
            components: [{
                name: 'priority'
            }, {
                name: 'secondaryPriority',
                hide: {
                    priority: ['Nothing Needed']
                }
            }, {
                name: 'priorityDetails',
                display: {
                    priority: ['Something Else']
                }
            }, {
                name: 'secondaryPriorityDetails',
                display: [
                    {
                        priority: [
                            'Monitor',
                            'Docking Station',
                            'Keyboard/Mouse',
                            'Web Cam',
                            'Headset',
                            'Office Chair',
                            'Desk',
                            'Adapters',
                            'Something Else'
                        ]
                    },
                    {
                        secondaryPriority: ['Something Else']
                    }
                ]
            }]
        },
        {
            id: 'additional-questions',
            allowedVersion: ['1.0', '1.1'],
            title: 'title',
            align: {
                title: 'center',
                description: 'center',
                text: 'center',
                info: 'center'
            },
            display: {
                country: ['USA', 'IND', 'CAN', 'BRA']
            },
            components: [
                {
                    name: 'improveWorkspace'
                },
                {
                    name: 'improveRemoteWorking'
                }
            ]
        }
    ],
    components: {
        workplace: {
            type: 'collection',
            cell: {
                class: 'col-6 col-md-4'
            },
            option: true,
            options: [{
                image: 'assets/images/quiz/workplace/dedicated_office.png',
                value: 'Dedicated Office',
                title: 'title',
                description: 'description'
            }, {
                image: 'assets/images/quiz/workplace/semi_dedicated_office_space.png',
                value: 'Semi-Dedicated',
                title: 'title',
                description: 'description'
            }, {
                image: 'assets/images/quiz/workplace/floating_office.png',
                value: 'Floating',
                title: 'title',
                description: 'description'
            }],
            validation: {
                required: true,
                messages: {
                    required: 'error.required'
                }
            },
            payload: {
                field: 'workplace'
            }
        },
        priority: {
            type: 'dropdown',
            wrapperCssClass: 'col-12 col-md-6 offset-lg-2 col-lg-4',

            options: [{
                value: 'Monitor',
                name: 'title',
            }, {
                value: 'Docking Station',
                name: 'title',
            }, {
                value: 'Keyboard/Mouse',
                name: 'title',
            }, {
                value: 'Web Cam',
                name: 'title',
            }, {
                value: 'Office Chair',
                name: 'title',
                hide: {
                    country: ['USA', 'CAN', 'IND', 'VNM', 'PHL']
                }
            }, {
                value: 'Desk',
                name: 'title',
                hide: {
                    country: ['USA', 'CAN', 'IND', 'VNM', 'PHL']
                }
            }, {
                value: 'Adapters',
                name: 'title'
            }, {
                value: 'Uninterruptible Power Supply (UPS)',
                name: 'title',
                display: {
                    country: ['IND']
                }
            }, {
                value: 'Something Else',
                name: 'title'
            }, {
                value: 'Nothing Needed',
                name: 'title'
            }],

            validation: {
                required: true,
                messages: {
                    requiredUnless: 'error.requiredUnless',
                    requiredIf: 'error.requiredIf',
                    required: 'error.required'
                }
            },
            payload: {
                field: 'priority',
                type: 'array'
            }
        },
        priorityDetails: {
            type: 'textbox',
            wrapperCssClass: 'col-12 col-md-6 offset-lg-2 col-lg-4',
            placeholder: 'placeholder',
            maxCharacters: 256,
            payload: {
                field: 'priorityDetails'
            },
            validation: {
                requiredIf: {
                    priority: ['Something Else']
                }
            }
        },
        secondaryPriority: {
            type: 'dropdown',
            wrapperCssClass: 'col-12 col-md-6 col-lg-4',
            disable: {
                priority: [null, '']
            },
            options: [{
                value: 'Monitor',
                name: 'title',
                hide: {
                    priority: ['Monitor']
                }
            }, {
                value: 'Second Monitor',
                name: 'title',
                display: {
                    priority: ['Monitor']
                }
            }, {
                value: 'Docking Station',
                name: 'title',
                hide: {
                    priority: ['Docking Station']
                }
            }, {
                value: 'Keyboard/Mouse',
                name: 'title',
                hide: {
                    priority: ['Keyboard/Mouse']
                }
            }, {
                value: 'Web Cam',
                name: 'title',
                hide: {
                    priority: ['Web Cam']
                }
            }, {
                value: 'Office Chair',
                name: 'title',
                hide: {
                    priority: ['Office Chair'],
                    country: ['USA', 'CAN', 'IND', 'VNM', 'PHL']
                }
            }, {
                value: 'Desk',
                name: 'title',
                hide: {
                    priority: ['Desk'],
                    country: ['USA', 'CAN', 'IND', 'VNM', 'PHL']
                }
            }, {
                image: 'assets/images/quiz/needs/DXC_computer_adapter.png',
                value: 'Adapters',
                name: 'title',
                hide: {
                    priority: ['Adapters']
                }
            }, {
                value: 'Uninterruptible Power Supply (UPS)',
                name: 'title',
                display: [{
                    country: ['IND']
                }, {
                    priority: [
                        'Monitor',
                        'Docking Station',
                        'Keyboard/Mouse',
                        'Web Cam',
                        'Office Chair',
                        'Desk',
                        'Adapters',
                        'Something Else',
                        'Nothing Needed'
                    ]
                }]
            }, {
                value: 'Something Else',
                name: 'title'
            }, {
                value: 'Nothing Needed',
                name: 'title'
            }],
            validation: {
                required: true,
                messages: {
                    requiredUnless: 'error.requiredUnless',
                    requiredIf: 'error.requiredIf',
                    required: 'error.required'
                }
            },
            payload: {
                field: 'secondaryPriority',
                type: 'array'
            }
        },
        secondaryPriorityDetails: {
            type: 'textbox',
            wrapperCssClass: {
                'col-12 col-md-6 col-lg-4': true,
                'offset-lg-0': {
                    priority: ['Something Else']
                },
                'offset-lg-6 offset-md-6': {
                    priority: ['Monitor', 'Docking Station', 'Keyboard/Mouse', 'Web Cam', 'Headset', 'Office Chair', 'Desk', 'Adapters', 'Nothing Needed']
                }
            },
            placeholder: 'placeholder',
            payload: {
                field: 'secondaryPriorityDetails'
            },
            maxCharacters: 256,
            validation: {
                requiredIf: {
                    secondaryPriority: ['Something Else']
                }
            },
        },
        improveWorkspace: {
            type: 'textarea',
            wrapperCssClass: 'offset-md-3 col-md-6',
            placeholder: 'placeholder',
            maxCharacters: 2000,
            payload: {
                field: 'improveWorkspace'
            }
        },
        improveRemoteWorking: {
            type: 'textarea',
            wrapperCssClass: 'offset-md-3 col-md-6',
            placeholder: 'placeholder',
            maxCharacters: 2000,
            payload: {
                field: 'improveRemoteWorking'
            }
        }
    }
}

export default profile